module.exports = __webpack_public_path__ + "assets/hello-elementor.9dd27359.svg";